import React from 'react';
import { useLocation } from 'react-router-dom';

import { getHashParams } from 'services/hash_params';

export function useHashParams() {
  const location = useLocation();
  return React.useMemo(() => getHashParams(location.hash), [location.hash]);
}
